<template>
  <div id="screening-formList">
    <el-card class="box-card left-card" v-for="(field,index) in projectsData" style="margin-bottom: 15px;">
          <div slot="header" class="clearfix">
            <span style="font-size: 16px;float: left;">{{field.projectName}}
                (
                  <span :style="{'font-size':'18px','font-weight':'bold','color':(field.checkStatus===1?'#FF5252':(field.checkStatus===2?'#4CAF50':'#FF9800A3'))}">
                    {{field.checkStatus===1 ? '未检查':(field.checkStatus===2? '已检查':'部分已检')}}
                  </span>
                )
            </span>
            <div :style="{'display':'flex','justify-content':'right'}">
              <Button style="font-size: 16px;" type="primary" size="small" @click="handleSubmit(field.projectId)">保存项目</Button>
            </div>
          </div>

          <Form :model="model[field.projectName]" :showMessage="false">
            <template v-for="(rowItem, rowIndex) in getRowElements(field.projectName, field.fieldConfig, field.checkStatus)">
              <Row v-if="rowItem.isStartIndex">
                <Col v-for="(item, colIndex) in getColElements(field.projectName, rowIndex)" :span="item.columnNumber?item.columnNumber:6" v-if="item.isShow">
                  <FormItem :prop="item.prop" :label="item.label" :label-width="item.labelWidth" :style="item.width" :required="item.isRequired&&item.isRequired==2">
                    <Input v-if="!item.element" :type="item.type" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"
                           :autocomplete="item.type === 'password' ? 'new-password' : ''"
                           @on-change="e=>changePropVal(field.projectName, item.prop, item.fieldCode, e.target.value)"
                           :size="item.size" :disabled="item.disabled" :readonly="item.readonly"
                           :icon="item.icon" :prefix="item.prefix" :suffix="item.suffix" :clearable="true"
                           :number="item.number" :rows="item.rows" :autosize="item.autosize" style="height:35px;width: 100%;" >
                      <span v-if="item.unit" slot="append">{{item.unit}}</span>
                    </Input>

                    <Input v-if="item.element === 'number'" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"
                           @on-keyup="e=>toInt(field.projectName, item.prop, item.startRange, item.endRange, e.target.value)"
                           @on-change="e=>changePropVal(field.projectName, item.prop, item.fieldCode, e.target.value)"
                           :size="item.size" :disabled="item.disabled" :readonly="item.readonly"
                           :icon="item.icon" :prefix="item.prefix" :suffix="item.suffix" :clearable="true"
                           :number="item.number" :rows="item.rows" :autosize="item.autosize" style="height:35px;width: 100%;">
                      <span v-if="item.unit" slot="append">{{item.unit}}</span>
                    </Input>

                    <!--
                    <Input v-if="item.element === 'digit'" :type="item.type" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"
                           @on-keyup="e=>toDigit(field.projectName, item.prop, item.startRange, item.endRange, e.target.value)"
                           @on-change="e=>changePropVal(field.projectName, item.prop, item.fieldCode, e.target.value)"
                           :size="item.size" :disabled="item.disabled" :readonly="item.readonly"
                           :icon="item.icon" :prefix="item.prefix" :suffix="item.suffix" :clearable="true"
                           :number="item.number" :rows="item.rows" :autosize="item.autosize" style="height:35px;width: 100%;">
                      <span slot="append" style="padding: 4px 7px;font-size: inherit;font-weight: 400;line-height: 1;color: #515a6e;text-align: center;background-color: #cf0909;border: 0px solid #dcdee2;border-radius: 4px;">aaa</span>
                      <span v-if="item.unit" slot="append">{{item.unit}}</span>
                    </Input>
                    -->

                    <div class="ivu-form-item-content" v-if="item.element === 'digit'" >
                      <div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text ivu-input-group ivu-input-group-default ivu-input-group-with-append ivu-input-hide-icon">
                        <Input :type="item.type" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"
                                @on-keyup="e=>toDigit(field.projectName, item.prop, item.startRange, item.endRange, e.target.value)"
                                @on-change="e=>changePropVal(field.projectName, item.prop, item.fieldCode, e.target.value)"
                                :size="item.size" :disabled="item.disabled" :readonly="item.readonly"
                                :icon="item.icon" :prefix="item.prefix" :suffix="item.suffix" :clearable="true"
                                :number="item.number" :rows="item.rows" :autosize="item.autosize" style="height:35px;width: 100%;"/>
                        <div class="ivu-input-group-append" style="background-color: rgb(221 63 63 / 12%);" v-if="item.historyValue">{{ item.historyValue }}</div>
                        <div class="ivu-input-group-append" v-if="item.unit">{{item.unit}}</div>
                      </div>
                    </div>

                    <Input v-if="item.element === 'textarea'" v-model="model[field.projectName][item.prop]" type="textarea" :placeholder="item.placeholder"
                           @on-change="e=>changePropVal(field.projectName, item.prop, item.fieldCode, e.target.value)" :clearable="true"
                           :size="item.size" :disabled="item.disabled" :readonly="item.readonly" :icon="item.icon" :prefix="item.prefix"
                           :suffix="item.suffix" :number="item.number" :rows="item.rows" :autosize="item.autosize" style="width: 100%;"/>

                    <!-- 选择器 -->
                    <Select v-if="item.element === 'select'" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"  :clearable="true"
                            :size="item.size" :disabled="item.disabled" :filterable="item.filterable" :multiple="item.multiple" :style="item.elemWidth"
                            @on-change="value=>changePropVal(field.projectName, item.prop, item.fieldCode, value)" transfer style="height:35px;width: 100%;">
                      <Option v-for="(opt, index) in item.option" :key="index" :value="opt.value" :disabled="opt.disabled">{{ opt.label }}</Option>
                    </Select>

                    <!-- 级联选择 -->
                    <MyCascader v-if="item.element === 'cascader'" :size="item.size" @on-change="value=>changePropVal(field.projectName, item.prop, item.fieldCode, value)"
                                :placeholder="item.placeholder" v-model="model[field.projectName][item.prop]" :options="item.option" :collapseTags="false" :code="item.code" :name="item.name"
                                :filterable="false" clearable  style="width: 100%" :disabled="item.disabled"/>

                    <!-- 日期选择器 -->
                    <DatePicker v-if="item.element === 'date'" :editable="false" :type="item.type" v-model="model[field.projectName][item.prop]"
                                :options="item.options" :format="item.format" :placeholder="item.placeholder" :size="item.size"
                                :disabled="item.disabled" :style="item.elemWidth" transfer
                                @on-change="value=>changePropVal(field.projectName, item.prop, item.fieldCode, value)" style="height:35px;width: 100%;"/>

                    <!-- 时间选择器 -->
                    <TimePicker v-if="item.element === 'time'" :type="item.type" v-model="model[field.projectName][item.prop]"
                                :format="item.format" :placeholder="item.placeholder" :size="item.size" :disabled="item.disabled"
                                :style="item.elemWidth" transfer
                                @on-change="value=>changePropVal(field.projectName, item.prop, item.fieldCode, value)" style="height:35px;width: 100%;"/>

                    <!-- 单选框 -->
                    <RadioGroup v-if="item.element === 'radio'" :type="item.type" v-model="model[field.projectName][item.prop]" :size="item.size" :vertical="item.vertical"
                                @on-change="value=>changePropVal(field.projectName, item.prop, item.fieldCode, value)" style="width: 100%">
                      <Radio v-for="(opt, index) in item.option" :key="index" :label="opt.value" :size="item.size" :disabled="opt.disabled"
                             @dblclick.native.prevent="()=>{model[field.projectName][item.prop] = null}">{{ opt.label }}</Radio>
                    </RadioGroup>

                    <!-- 多选框 -->
                    <MyCheckBox :key="item.prop+index" v-if="item.element === 'checkbox'" :ignore-list="item.ignoreList" :enumList="item.option" :dataStr.sync="model[field.projectName][item.prop]"
                                :disabled="item.disabled" @on-change="value=>changePropVal(field.projectName, item.prop, item.fieldCode, value)" style="width: 100%"/>

                  </FormItem>
                </Col>
              </Row>
            </template>
          </Form>
      </el-card>
  </div>
</template>
<script>
import {_getPhysicalForm, _savePhysicalForm} from "@/services/screening/screeningDatainfo";
export default {
  name: "ScreeningFormList",
  props: {
    physicalId:[String,Number],
    barCode:[String,Number],
    physicalDate:[String],
    queryProjectsData:{
      type: Array,
      default:()=>[]
    },
  },
  computed:{

  },
  watch:{

  },
  data() {
    return {
      activeNames:[],
      model:{},
      bmiModel:{heightId:"",weightId:"",bmiId:""},
      modelProjectIdMap:{},
      fieldConfigMap:{},
      projectElements:[],
      fieldFomat: [],
      projectsData: [],
      modalShow: false,
      collapseItemShow:false,
      yueXiuTempalte : false,
      huangPuTempalte : false,
      projectFields: [],
    };
  },
  mounted() {
    this.yueXiuTempalte = this.$userSession.yueXiuTemplate();
    this.huangPuTempalte = this.$userSession.huangPuTemplate();
    this.projectsData = [...this.queryProjectsData];

    this.fieldFomat = this.defineFomat();
    this.model = {}
    this.modelProjectIdMap = {}
    this.projectElements = []
    this.projectsData.forEach(item=>{
      this.model[item.projectName] = {}
      // this.modelProjectIdMap[item.projectName] = item.projectId;
      this.modelProjectIdMap[item.projectName] = {projectId:item.projectId, isRequired:item.isRequired};
      this.activeNames.push(item.projectName);
    })
    this.collapseItemShow = true;
    this.bmiModel = {heightId:"",weightId:"",bmiId:""};
    this.$forceUpdate();
  },
  methods: {
    defineFomat(){
      const map = new Map();
      map.set(1, this.formatInput)
      map.set(2, this.formatNumberInput)
      map.set(3, this.formatDigitInput)
      map.set(4, this.formatRadio)
      map.set(5, this.formatRadio)
      map.set(6, this.formatCheckBox)
      map.set(7, this.formatCheckBox)
      map.set(8, this.formatSelect)
      map.set(9, this.formatSelect)
      map.set(10, this.formatCascader)
      map.set(11, this.formatCascader)
      map.set(12, this.formatDatePicker)
      map.set(13, this.formatYearPicker)
      map.set(14, this.formatYearMonthPicker)
      map.set(15, this.formatTextArea)
      return map
    },
    applyPhysicalForm(){
      this.projectsData = [];
      _getPhysicalForm({physicalId:  this.$props.physicalId}).then(res=>{
        if (res.errcode === 1){
          this.projectsData = Object.assign([],res.data);
        }
      })
    },
    handleSubmit(_projectId){
      this.projectFields = [];
      let warnList = [];
      for(let key in this.model){
        let projectId = this.modelProjectIdMap[key].projectId;
        if(_projectId && _projectId != projectId){
          continue;
        }
        let isRequired = this.modelProjectIdMap[key].isRequired;
        let fieldDatas = this.model[key];

        let fieldConfigs = [];
        for (let fieldId in fieldDatas){
          let projectValue = fieldDatas[fieldId];

          let item = {fieldId: fieldId}
          if(projectValue && projectValue.length > 0){
            item.projectValue = projectValue;
          }
          fieldConfigs.push(item)

          let fieldElement = this.fieldConfigMap[fieldId];
          if(!projectValue && fieldElement.isRequired && fieldElement.isRequired == 2){
            if(isRequired&&isRequired==2){
              let errmsg = fieldElement.elementType==1||fieldElement.elementType==2||fieldElement.elementType==3||fieldElement.elementType==15?" 填写 ":" 选择 ";
              this.$message.warning("请" + "【" + key + "】" + errmsg + fieldElement.fieldName);
              return;
            }else{
              let errmsg = fieldElement.elementType==1||fieldElement.elementType==2||fieldElement.elementType==3||fieldElement.elementType==15? "  未填写":"  未选择";
              warnList.push({name:"【" + key + "】-- " + fieldElement.fieldName, label:errmsg});
            }
          }
        }

        this.projectFields.push({
          projectId: projectId,
          fieldConfigs: fieldConfigs
        })
      }

      if(warnList && warnList.length > 0){
        let message = "";
        for(let index in warnList){
          let item = warnList[index];
          message += "<div>" + item.name + "   <span style='color: red;'>" + item.label + "</span></div>";
        }

        this.$confirm("<div style='max-height: 300px;overflow-y:auto'>" + message + "</div>", '提示', {
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '返回'
        }).then(() => {
          this.toSave();
        }).catch(() => {});
      }else{
        this.toSave();
      }
    },
    toSave(){
      let params = {
        physicalId: this.$props.physicalId,
        barCode: this.$props.barCode,
        projectFields: this.projectFields
      }

      _savePhysicalForm(params).then(res=>{
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit('on-success');
        }else{
          this.$message.error(res.errmsg);
        }
      })
    },
    //####################表单的渲染方法############################
    getRowElements(projectName, configs, checkStatus){
      let elements = this.projectElements[projectName];
      if(elements && elements.length > 0) {
        return elements;
      }

      elements = [];
      let filer = this.fieldFomat;
      configs.forEach((field, index)=>{
        this.fieldConfigMap[field.fieldId] = field;

        //设置表单
        let callback = filer.get(field.elementType)
        if (callback){
          let ele = callback(field)
          if (ele !== null){
            ele.optionIndex = index;
            ele.isStartIndex = index == 0 ? true : false;
            elements.push(ele);
          }
        }

        //设置表单值
        if (field.projectValue){
          this.model[projectName][field.fieldId] = field.projectValue;
        }else if(field.defaultValue && (!checkStatus || checkStatus == 1)){
          this.model[projectName][field.fieldId] = field.defaultValue;
        }else{
          this.model[projectName][field.fieldId] = "";
        }

        if(field.fieldCode === 'height'){
          this.bmiModel.heightId = field.fieldId;
        }else if(field.fieldCode === 'weight'){
          this.bmiModel.weightId = field.fieldId;
        }else if(field.fieldCode === 'bmi'){
          this.bmiModel.bmiId = field.fieldId;
        }
      })
      this.$set(this, "model", this.model);

      this.projectElements[projectName] = elements;
      return elements;

    },
    getColElements(projectName, rowIndex){
      let elements = this.projectElements[projectName];
      elements = elements.filter((item, index) => index >= rowIndex);
      let elementColumn = 0;
      elements.forEach((field, index) => {
        if(elementColumn < 24){
          field.isShow = true;
          elementColumn += (!field.columnNumber ? 6 : field.columnNumber);
          if(elementColumn >= 24 && index != (elements.length - 1)){
            elements[index + 1].isStartIndex = true;
          }
        }else{
          field.isShow = false;
        }
      });
      return elements;
    },
    countChineseChars(str) {
      let count = 0;
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) >= 0x4e00 && str.charCodeAt(i) <= 0x9fff) {
          count++;
        }
      }
      return count;
    },
    calFieldNameLength(fieldName){
      if(!fieldName) {
        return 30;
      }

      let length = this.countChineseChars(fieldName);
      if(fieldName.length !== length){
        length = length + (fieldName.trim().length - length - 1);
      }

      let width = 45;
      if(length === 2){
        width = 60;
      }else if(length === 3){
        width = 75;
      }else if(length === 4){
        width = 88;
      }else if(length === 5){
        width = 100;
      }else if(length === 6){
        width = 115;
      }else if(length === 7){
        width = 135;
      }else if(length === 8){
        width = 145;
      }else if(length === 9){
        width = 150;
      }else if(length === 10){
        width = 155;
      }else if(length === 11){
        width = 160;
      }else if(length === 12){
        width = 165;
      }else if(length === 13){
        width = 170;
      }else if(length === 14){
        width = 175;
      }else if(length === 150){
        width = 180;
      }

      if(fieldName.indexOf("(") > -1){
        width = width + 5;
      }

      return width;
    },
    setFormParam(field, element, placeholder){
      let obj = Object.assign({}, field);
      obj.label = field.fieldName;
      obj.fieldCode = field.fieldCode;
      obj.prop = field.fieldId + '';
      obj.disabled = field.isRead === 2;
      obj.isRequired = field.isRequired;
      obj.labelWidth = this.calFieldNameLength(field.fieldName);
      obj.minWidth = 140;
      obj.width = {'font-weight': 'bold'};

      if(placeholder){
        obj.placeholder = placeholder;
      }
      if(element){
        obj.element = element;
      }

      return obj;
    },
    formatInput(field){
      let obj = this.setFormParam(field, null, "请输入");
      obj.width = {'font-weight': 'bold', 'height': '35px', 'line-height': '35px'};
      if (field.unit){
        obj.unit = field.unit;
      }
      return obj
    },
    formatNumberInput(field){
      let obj = this.setFormParam(field, "number", "请输入");
      obj.width = {'font-weight': 'bold', 'height': '35px', 'line-height': '35px'};
      obj.elemWidth = {'height': '35px'};

      if (field.startRange){
        obj.max= parseFloat(field.startRange)
      }
      if (field.endRange){
        obj.min= parseFloat(field.endRange)
      }
      if (field.unit){
        obj.unit = field.unit;
      }
      return obj
    },
    formatDigitInput(field){
      let obj = this.setFormParam(field, "digit", "请输入");
      obj.width = {'font-weight': 'bold', 'height': '35px', 'line-height': '35px'};

      if (field.decimalLimit){
        obj.step = field.decimalLimit === 1 ? 0.1 : (field.decimalLimit === 2 ? 0.01 : 1)
      }else {
        obj.step=0.01
      }
      if (field.startRange){
        obj.max= parseFloat(field.startRange)
      }
      if (field.endRange){
        obj.min= parseFloat(field.endRange)
      }
      if (field.unit){
        obj.unit = field.unit;
      }
      return obj
    },
    formatRadio(field){
      let obj = this.setFormParam(field, "radio");
      obj.option = this.loadOptions(field);
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    formatCheckBox(field){
      let options = [];
      let ignoreList = field.mutexIds ? field.mutexIds: [];
      if (field.options){
        field.options.forEach(item=>{
          let option  = {value: item.name, code: item.id+''}
          options.push(option)
          if(item.isDefault && item.isDefault === 2 && !ignoreList.includes(item.id+'')){
            ignoreList.push(item.id+'')
          }
        })
      }

      let obj = this.setFormParam(field, "checkbox");
      obj.option = options;
      obj.width = {'font-weight': 'bold'};
      obj.ignoreList = ignoreList;

      return obj;
    },
    formatSelect(field){
      let obj = this.setFormParam(field, "select");
      obj.option = this.loadOptions(field);
      obj.width = {'font-weight': 'bold'};
      return obj
    },
    formatTextArea(field){
      let obj = this.setFormParam(field, "textarea");
      obj.autosize = {minRows: 4};
      // obj.width = {'font-weight': 'bold', 'width': '1000px'};
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    //渲染树状选择框
    formatCascader(field){
      let obj = this.setFormParam(field, "cascader", "请选择");
      obj.option = this.loadOptions(field);
      obj.code = "id";
      obj.name = "name";
      obj.width = {'font-weight': 'bold'};
      obj.elemWidth = {'width': '300px'};
      obj.elemWidth = {};
      obj.filterable = true;
      return obj;
    },
    formatYearPicker(field){
      let obj = this.setFormParam(field, "date", "请选择");
      obj.type = 'year';
      obj.format = 'yyyy';
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    formatYearMonthPicker(field){
      let obj = this.setFormParam(field, "date", "请选择");
      obj.type = 'year';
      obj.format = 'yyyy-MM';
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    formatDatePicker(field){
      let obj = this.setFormParam(field, "date", "请选择");
      obj.type = 'date';
      obj.format = 'yyyy-MM-dd';
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    loadOptions(field){
      let options = [];
      if (field.treeOptions && !field.options){
        options = field.treeOptions;
      }else if (!field.treeOptions && field.options){
        field.options.forEach(item=>{
          options.push({label: item.name, value: item.id})
        })
      }
      return options
    },
    //值改变封装
    changePropVal(projectName, propName, fieldCode, value){
      this.model[projectName][propName] = value;
      if(fieldCode === 'height'){
        this.countBMI(projectName, value, null);
      }else if(fieldCode === 'weight'){
        this.countBMI(projectName, null, value);
      }
      this.$nextTick(()=>{ this.$forceUpdate();})
    },
    countBMI(projectName, height, weight) {
      if(!this.bmiModel.heightId || !this.bmiModel.weightId || !this.bmiModel.bmiId){
        this.model[projectName][this.bmiModel.bmiId] = "";
        this.$nextTick(()=>{ this.$forceUpdate();})
        return;
      }

      height = height ? height : this.model[projectName][this.bmiModel.heightId];
      weight = weight ? weight : this.model[projectName][this.bmiModel.weightId];
      if(!height || height === '' || !weight || weight === ''){
        this.model[projectName][this.bmiModel.bmiId] = "";
        this.$nextTick(()=>{ this.$forceUpdate();})
        return;
      }

      let bmi = parseFloat(weight) / ((parseFloat(height) / 100) * (parseFloat(height) / 100))
      this.model[projectName][this.bmiModel.bmiId] = this.yueXiuTempalte || this.huangPuTempalte ? bmi.toFixed(1).toString() : bmi.toFixed(2).toString();
      this.$nextTick(()=>{ this.$forceUpdate();})
    },
    toDigit(projectName, propName, startRange, endRange, value){
      if(!value){
        return;
      }
      this.model[projectName][propName] = value
      this.model[projectName][propName] = this.model[projectName][propName].replace(/[^\d.]/g, '');
      // 必须保证第一个为数字而不是.
      this.model[projectName][propName] = this.model[projectName][propName].replace(/^\./g, '');
      // 保证只有出现一个.而没有多个.
      this.model[projectName][propName] = this.model[projectName][propName].replace(/\.{2,}/g, '');
      // 保证.只出现一次，而不能出现两次以上
      this.model[projectName][propName] = this.model[projectName][propName].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');

      if (this.model[projectName][propName].indexOf('.') !== -1 && this.model[projectName][propName].length > 6) {
        this.model[projectName][propName] = this.model[projectName][propName].substring(0,6);
      }else if(this.model[projectName][propName].indexOf('.') === -1 && this.model[projectName][propName].length > 5){
        this.model[projectName][propName] = this.model[projectName][propName].substring(0,5);
      }

      let count = -1
      for (let i in this.model[projectName][propName]) {
        if (this.model[projectName][propName][i] === '.') {
          count = i
        }
        if (count !== -1) {
          if ((i - count) > 1) {
            this.model[projectName][propName] = this.model[projectName][propName].substring(0, this.model[projectName][propName].length - 1)
          }
        }
      }

      if(this.model[projectName][propName] && this.model[projectName][propName].length > 0 && startRange && parseFloat(this.model[projectName][propName]) < parseFloat(startRange)){
        this.model[projectName][propName] = "";
      }else if(this.model[projectName][propName] && this.model[projectName][propName].length > 0 && endRange && parseFloat(this.model[projectName][propName]) > parseFloat(endRange)){
        this.model[projectName][propName] = "";
      }

      this.$nextTick(()=>{ this.$forceUpdate();})
    },
    toInt(projectName, propName, startRange, endRange, value){
      if(!value){
        return;
      }
      this.model[projectName][propName] = value
      this.model[projectName][propName] = this.model[projectName][propName].replace(/[^\d]+/g, '');
      this.model[projectName][propName] = this.model[projectName][propName].replace('.', '');
      this.model[projectName][propName] = this.model[projectName][propName].replace(/\./g, '');
      this.model[projectName][propName] = this.model[projectName][propName].replace(/\\./g, '');
      this.model[projectName][propName] = this.model[projectName][propName].replace('$#$', '');
      if(this.model[projectName][propName].length > 3){
        this.model[projectName][propName] = this.model[projectName][propName].substring(0,3);
      }
      let count = -1
      for (let i in this.model[projectName][propName]) {
        if (this.model[projectName][propName][i] === '.') {
          count = i
        }
        if (count !== -1) {
          if ((i - count) > 1) {
            this.model[projectName][propName] = this.model[projectName][propName].substring(0, this.model[projectName][propName].length - 1)
          }
        }
      }

      if(this.model[projectName][propName] && this.model[projectName][propName].length > 0 && startRange && parseInt(this.model[projectName][propName]) < parseInt(startRange)){
        this.model[projectName][propName] = "";
      }else if(this.model[projectName][propName] && this.model[projectName][propName].length > 0 && endRange && parseInt(this.model[projectName][propName]) > parseInt(endRange)){
        this.model[projectName][propName] = "";
      }

      this.$nextTick(()=>{ this.$forceUpdate();})
    }
  }
};
</script>
<style lang="postcss" scoped>
/* 隐藏箭头 */
::v-deep .el-collapse-item__arrow {display: none !important;}
/* 阻止标题区域点击 */
::v-deep .el-collapse-item__header {pointer-events: none;  /* 禁止所有交互 */border: none;padding-bottom: 0;}
::v-deep .el-collapse-item__wrap {border: none;}
/* 恢复内容区域的交互（可选） */
::v-deep .el-collapse-item__content {pointer-events: auto;font-size: 13px;color: #303133;line-height: 1.769230769230769;}
/deep/.ivu-input {height: 36px;}
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.ivu-checkbox-disabled+span {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.el-input.is-disabled .el-input__inner {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.ivu-select-disabled .ivu-select-selection {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}

/deep/ .el-input__inner {color: var('--inputColor');}
/deep/ .el-input-group__prepend {color: var('--inputPrependColor');}
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input{color: rgba(46, 46, 46, 0.83);}

</style>
